import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// import parse from "html-react-parser";

import { CadastroSimples } from "../../data/interfaces";
import * as images from "../../images/images";
import * as api from "../../services/firebase";
import { Container, Imagem, Titulo, PromocaoContainer, Action } from "./styles";

export default function Promocao() {
  const [promocoes, setPromocoes] = useState<CadastroSimples[]>();
  const { tipo } = useParams();

  useEffect(() => {
    if (tipo) {
      api.getListaPromocao(tipo, (cadastros: CadastroSimples[]) => {
        setPromocoes(cadastros);
      });
    }
  }, [tipo]);

  return (
    <>
      <Imagem src={images.imgExc4} alt="foto" />
      <Container>
        {promocoes?.map((itens) => (
          <PromocaoContainer>
            <Action href={itens.link} target="_blank" rel="noreferrer noopener">
              <Imagem src={itens?.urlImage} alt="foto" />
            </Action>
            <Titulo>{itens.descricao}</Titulo>
            {/* <Texto>
              {itens.texto ? (
                parse(itens?.texto)
              ) : (
                <Mensagem>Sem dados</Mensagem>
              )}
            </Texto> */}
          </PromocaoContainer>
        ))}
      </Container>
    </>
  );
}
